import { lazy } from "react";

export { EMPLOYEE_PROFILE_PATH } from "./employee-profile-path";
export const EmployeeProfile = lazy(() => import("./employee-profile"));
export { ToEmployeeProfileLink } from "./to-employee-profile-link";
